// src/App.tsx
import React from 'react';
import './App.css';
import AppRoutes from './router';
import Nav from './components/nav';
import { AuthProvider } from './context/auth-context';

import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Nav />
        <main>
          <AppRoutes />
        </main>
      </Router>
    </AuthProvider>
  );
}

export default App;
